import { render, staticRenderFns } from "./template-email.vue?vue&type=template&id=49fbeded&scoped=true&"
import script from "./template-email.vue?vue&type=script&lang=js&"
export * from "./template-email.vue?vue&type=script&lang=js&"
import style0 from "./template-email.vue?vue&type=style&index=0&id=49fbeded&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49fbeded",
  null
  
)

export default component.exports